<div
        [ngClass]="{'outline': outlined}"
        class="row no-gutters position-relative"
>
    <div class="col-md-6 col-12">
        <mat-form-field
                [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
                [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
                class="custom-autocomplete"
        >
            <mat-label *ngIf="asFormsControl().outline">{{ codePlaceholder ? codePlaceholder : 'Country Code' }}</mat-label>

            <div
                    *ngIf="selectedOption"
                    [ngClass]="!selectedOption.classes ? '' : selectedOption.classes"
                    class="flag-wrapper"
            ></div>

            <input
                    matInput
                    #autocompleteInput
                    type="text"
                    [matAutocomplete]="autocomplete"
                    [placeholder]="codePlaceholder ? codePlaceholder : 'Country Code'"
                    [ngClass]="{'with-flag': selectedOption}"

                    (input)="filterCodes($event)"
                    (paste)="filterCodesOnPaste($event)"
            >

            <i class="arrow-down-triangle" aria-hidden="true"></i>

            <mat-autocomplete
                #autocomplete="matAutocomplete"
                (optionSelected)="enterCode($event)"
                (opened)="onTouched && onTouched()"
            >
                <mat-option
                        *ngFor="let code of filteredCodes | async"
                        [value]="code.value"
                >
                    <div class="select-item">
                        <span [ngClass]="code.classes"></span>
                        <span>{{code.label}}</span>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div class="col-md-6 col-12">
        <div class="pl-3">
            <mat-form-field
                    [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
                    [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"

                    class="app-input"
            >
                <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

                <input
                        matInput
                        #input
                        [placeholder]="asFormsControl().placeholder"
                        (input)="enterPhone($event)"
                        (focus)="onTouched && onTouched()">
            </mat-form-field>
        </div>
    </div>
</div>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

